<div>
  <file-pond #myPond [options]="pondOptions" (onupdatefiles)="onUpdateFiles()"></file-pond>
</div>
